module.exports = "/3/2-vong-lap-for/index.html.383b7c1bbb3e656af3a23d3c35402d14.json"


/*****************
 ** WEBPACK FOOTER
 ** ./content/generated/30013.md
 ** module id = 545
 ** module chunks = 0
 **/